import type { useRemoveAuthenticationToken } from "src/authentication/hooks/useRemoveAuthenticationToken";
import type { Message } from "src/shared/messages/components/Messages";

export const ADD_MESSAGE = Symbol("ADD_MESSAGE");
export const REMOVE_MESSAGE = Symbol("REMOVE_MESSAGE");
export const REGISTER_REMOVE_AUTHENTICATION_TOKEN = Symbol(
  "REGISTER_REMOVE_AUTHENTICATION_TOKEN",
);

export interface IAppState {
  messages: Message[];
  removeAuthenticationTokenHandler: ReturnType<
    typeof useRemoveAuthenticationToken
  >;
}

export interface IAppReducerMessageAction {
  type: typeof ADD_MESSAGE | typeof REMOVE_MESSAGE;
  message?: Message;
}
export interface IAppReducerRemoveAuthenticationTokenAction {
  type: typeof REGISTER_REMOVE_AUTHENTICATION_TOKEN;
  removeAuthenticationTokenHandler: ReturnType<
    typeof useRemoveAuthenticationToken
  >;
}

export type IAppReducerAction =
  | IAppReducerMessageAction
  | IAppReducerRemoveAuthenticationTokenAction;

const initialState: IAppState = {
  messages: [],
  removeAuthenticationTokenHandler: () => Promise.resolve(),
};

export default function AppReducer(
  state: IAppState = initialState,
  action: IAppReducerAction,
): IAppState {
  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.message],
      };
    case REMOVE_MESSAGE:
      const messages: Message[] = [...state.messages];
      const index: number = messages.indexOf(action.message);
      if (index === -1) {
        return state;
      }
      messages.splice(index, 1);
      return {
        ...state,
        messages,
      };
    case REGISTER_REMOVE_AUTHENTICATION_TOKEN:
      return {
        ...state,
        removeAuthenticationTokenHandler:
          action.removeAuthenticationTokenHandler,
      };
    default:
      return state;
  }
}
